import React, { useEffect, Component } from 'react';
import { initMetaPixel } from './components/pixel';
import { ProgressBar, UrgencyBar, StickyCTA, ExitPopup, PurchaseToasts } from './components/ConversionComponents';
import { Hero, Identification, CostOfInaction, Comparison } from './components/Sections1';
import { MethodRaiz, Authority, Testimonials, Benefits } from './components/Sections2';
import { Deliverables, Bonuses, OfferSummary, Checkout, MicroTrust } from './components/Sections3';
import { FAQ, EmotionalClose, Footer } from './components/Sections4';
import { RecipesShowcase } from './components/RecipesShowcase';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-body text-gray-800 selection:bg-herbal/30 selection:text-petroleum" data-id="element-0">
      {/* Conversion Components */}
      <ProgressBar data-id="element-1" />
      <UrgencyBar data-id="element-2" />
      <StickyCTA data-id="element-3" />
      <ExitPopup data-id="element-4" />
      <PurchaseToasts data-id="element-5" />

      {/* Main Content Sections */}
      <main className="pt-10" data-id="element-6">
        {' '}
        {/* Padding top to account for fixed UrgencyBar */}
        <Hero data-id="element-7" />
        <Identification data-id="element-8" />
        <CostOfInaction data-id="element-9" />
        <Comparison data-id="element-10" />
        <MethodRaiz data-id="element-11" />
        <Authority data-id="element-12" />
        <Testimonials data-id="element-13" />
        <OfferSummary data-id="element-14" />
        <Benefits data-id="element-15" />
        <RecipesShowcase data-id="element-16" />
        <Deliverables data-id="element-17" />
        <Bonuses data-id="element-18" />
        <Checkout data-id="element-19" />
        <MicroTrust data-id="element-20" />
        <FAQ data-id="element-21" />
        <EmotionalClose data-id="element-22" />
      </main>

      {/* Footer */}
      <Footer data-id="element-23" />
    </div>;
}